import {Card, Container, Group, Menu, rem, Space, Tabs, Text, Title, UnstyledButton} from "@mantine/core";
import {useLocation, useNavigate} from "react-router-dom";
import {PropsWithChildren, useCallback} from "react";
import {WellEntity} from "@ots-frontend/ots-data";
import {WellDetails} from "./WellDetails";
import {createContentStyles} from "../../../theme/useContentStyles";
import {IconChevronDown} from "@tabler/icons-react";
import {useTranslation} from "react-i18next";
import {WellAction, WellActionMenuDropdown} from "../../menu/WellActionMenu/WellActionMenu";
import {useWellUpdate} from "../../../hooks/useWellUpdate";
import {ObjectChangeLogView} from "../common/ObjectChangeLogView/ObjectChangeLogView";

const useStyles = createContentStyles((theme) => ({
  mainSection: {
    paddingBottom: theme.spacing.sm
  }
}));

export type WellProfileProps = PropsWithChildren<{
  well: WellEntity
}>

const tabs = [
  {
    key: "details",
    value: "Details"
  },
  {
    key: "history",
    value: "Change Logs"
  },
];

export const WellProfile = (props: WellProfileProps) => {
  const {well} = props;

  const {classes} = useStyles();

  const navigate = useNavigate();
  const {state} = useLocation();
  const {t} = useTranslation()

  const {
    deleteWell
  } = useWellUpdate()

  const onActionClick = useCallback((action: WellAction) => {
    // TODO: implement action click
  }, [well, navigate, deleteWell])

  const items = tabs.map((tab) => (
    <Tabs.Tab value={tab.key} key={tab.key}>
      {tab.value}
    </Tabs.Tab>
  ));

  return (
    <Card shadow="sm" padding="lg" mb="lg" radius="md" withBorder>
      <Container fluid={true} className={classes.mainSection}>
        <Group position="apart">
          <Title order={4}>Well: {well.name}</Title>

          <Menu
            width={260}
            position="bottom-end"
            transitionProps={{transition: "pop-top-right"}}
            withinPortal
          >
            <Menu.Target>
              <UnstyledButton>
                <Group spacing={7}>
                  <Text weight={500} size="sm" sx={{lineHeight: 1}} mr={3}>
                    {t("common.action.plural", "Actions")}
                  </Text>
                  <IconChevronDown size={rem(12)} stroke={1.5}/>
                </Group>
              </UnstyledButton>
            </Menu.Target>
            <Menu.Dropdown>
              <WellActionMenuDropdown well={well} onActionClick={onActionClick}/>
            </Menu.Dropdown>
          </Menu>

        </Group>
      </Container>

      <Card.Section>
        <Container fluid={true}>
          <Tabs
            defaultValue={state?.tabValue ?? "details"}
            onTabChange={(value) => navigate(`?id=${well.id}`, {state: {tabValue: value}})}
          >
            <Tabs.List>{items}</Tabs.List>
            <Space h="md"/>
            <Tabs.Panel value="details">
              <WellDetails well={well}/>
            </Tabs.Panel>
            <Tabs.Panel value="history">
              <ObjectChangeLogView entity={well}/>
            </Tabs.Panel>
          </Tabs>
        </Container>
      </Card.Section>
    </Card>
  );
};
